/*
 * props:
 * question
 * userAnswer:
 * analysisAnswer
 * */


import React ,{Component} from 'react';
import Material from 'components/Practice/Material';
import style from './question.css';
import AnswerAnalysis from 'components/Practice/Material/AnswerAnalysis.js';
import Audio from 'components/Common/Audio';
import config from 'config';
export default class BlankQuestion extends Component{
  componentDidMount() {

  }
  render() {
    const {analysisAnswer , question ,userAnswer} = this.props;
    return (
      <div>
        <Material stem={ question }/>
        {
          userAnswer.answer ?
            <div className={style.speakingMyAnswer}>
              <Audio src={`${config.cdnCommon}/${userAnswer.answer.audioPath}`}></Audio>
            </div>
             : null
        }
        <AnswerAnalysis analysisAnswer={ analysisAnswer } />
      </div>
    )
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/Answer/Question/SpeakingQuestion.js
 **/